import { Mediums } from "../../types/mediums";
import InternetMenuItems from "../internet-menu-items";
import MenuItem from "./menu-item";
import AuthContext from "../auth-context";
import { useContext } from "react";

export interface IMenuItemsProps {
  medium: Mediums | undefined;
  onShow: (isVisible: boolean) => void;
  onCollapse: (isCollapsed: boolean) => void;
}

export default function MenuItems({
  medium,
  onShow,
  onCollapse,
}: IMenuItemsProps) {
  const context = useContext(AuthContext);
  const customerInfo = context.customerInfo;

  return (
    <nav aria-label="Main">
      <ul className="nav flex-column mt-2">
        <MenuItem
          title="داشبورد"
          to="/"
          active
          fadeable
          icon="tachometer-alt"
          iconBgc="primary-tp1"
          onShow={() => onShow(false)}
          onCollapse={() => onCollapse(true)}
        />
        <MenuItem
          title="لیست سرویس ها"
          to="/services"
          icon="file"
          iconBgc="red-tp1"
          fadeable
          onShow={() => onShow(false)}
          onCollapse={() => onCollapse(true)}
        />

        <MenuItem
          title="مالی"
          icon="money-bill-wave"
          iconBgc="green-tp1"
          fadeable
          onShow={() => onShow(false)}
          onCollapse={() => onCollapse(true)}
        >
          <MenuItem
            title="خریدها"
            to="/withdraws"
            fadeable
            onShow={() => onShow(false)}
            onCollapse={() => onCollapse(true)}
          />
          <MenuItem
            title="پرداخت ها"
            to="/payments"
            fadeable
            onShow={() => onShow(false)}
            onCollapse={() => onCollapse(true)}
          />
          {customerInfo?.user != null && (
            <MenuItem
              title="ثبت فیش بانکی"
              to="/registerBankReceipt"
              fadeable
              onShow={() => onShow(false)}
              onCollapse={() => onCollapse(true)}
            />
          )}
        </MenuItem>

        {(medium === Mediums.ADSL || medium === Mediums.TdLte) && (
          <InternetMenuItems
            onShow={() => onShow(false)}
            onCollapse={() => onCollapse(true)}
          />
        )}
      </ul>
    </nav>
  );
}
